// extracted by mini-css-extract-plugin
export default {"container":"ChunkErrorBoundary__container___BJX1U","icon":"ChunkErrorBoundary__icon___wUPCw"};